import React from 'react';

import { addStory } from 'lib/story-books';

import { Label } from '.';

addStory('form-label', () => <Label>Heading1</Label>);
